import { defineMessages } from 'react-intl'
import defaultJson from './default.json'

const tmpDefaultLocale = navigator.language ? navigator.language : navigator.userLanguage ? navigator.userLanguage : 'en'
const defaultLocale = tmpDefaultLocale.substring(0, 1)

const defaultMessages = defineMessages(defaultJson)

export { defaultMessages, defaultLocale }
